import * as LabelPrimitive from "@radix-ui/react-label"
import * as React from "react"

import { cn } from "@/modules/helpers/hooks/shared/utils"
type RequiredLabelProps = React.ComponentProps<typeof LabelPrimitive.Root> & {
  required?: boolean
}
function Label({ className, required, ...props }: RequiredLabelProps) {
  return (
    <div className="flex items-center gap-1">
      <LabelPrimitive.Root
        data-slot="label"
        className={cn(
          "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
          className
        )}
        {...props}
      />
      {required && <span className="text-red-500 text-xs">*</span>}
    </div>
  )
}

export { Label }
